"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "screenShareCount", {
  enumerable: true,
  get: function get() {
    return _screenShareCount["default"];
  }
});
var _screenShareCount = _interopRequireDefault(require("./screenShareCount"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }